import React, { useState } from 'react'
import styles from './ContentAdviceAccordion.module.scss'

import classNames from 'classnames'

import ContentAdvice from '@/component/Primitive/ContentAdvice/ContentAdvice'
import { Accordion } from '../Accordion/Accordion'
import { array, string, bool } from 'prop-types'

const ContentAdviceAccordion = ({
  visualAdviceLayer,
  classification,
  visibleDefault,
  primaryAssetNonDefiningIssues
}) => {
  const hasOverview =
    visualAdviceLayer.overview &&
    visualAdviceLayer.overview.find(
      (item) => item.strength && item.strength > 0
    )
  const [viewDetails, setViewDetails] = useState(!hasOverview)

  return (
    <Accordion title="Content Advice" visibleDefault={visibleDefault}>
      <>
        {hasOverview && (
          <div className={styles.ActionButtons}>
            <button
              className={classNames(
                styles.ActionButton,
                !viewDetails && styles.ActiveButton
              )}
              onClick={() => setViewDetails(false)}
            >
              Overview
            </button>

            <button
              className={classNames(
                styles.ActionButton,
                viewDetails && styles.ActiveButton
              )}
              onClick={() => setViewDetails(true)}
            >
              More Info
            </button>
          </div>
        )}
        {viewDetails ? (
          <ContentAdvice
            showDescription
            data={visualAdviceLayer.details}
            rating={classification.toLowerCase()}
            showOnMobile
            hideDots={!hasOverview}
            primaryAssetNonDefiningIssues={primaryAssetNonDefiningIssues}
          />
        ) : (
          <ContentAdvice
            data={visualAdviceLayer.overview}
            rating={classification.toLowerCase()}
            showOnMobile
          />
        )}
      </>
    </Accordion>
  )
}
ContentAdviceAccordion.propTypes = {
  visualAdviceLayer: array,
  classification: string,
  visibleDefault: bool,
  primaryAssetNonDefiningIssues: string
}
export default ContentAdviceAccordion
